import { FilterAltOff } from '@mui/icons-material';
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Tooltip,
} from '@mui/material';
import { FILTER_BY_NO_CLINIC_ID } from 'globalConstants';
import { FC, useContext } from 'react';
import { ClinicContext } from 'state/contexts/clinic';

export type FiltersChangedArgs = {
  clinicId: number;
};

export const DEFAULT_FILTERS: FiltersChangedArgs = {
  clinicId: FILTER_BY_NO_CLINIC_ID,
};

type Props = {
  selectedFilters: FiltersChangedArgs;
  onFiltersChanged: (args: Partial<FiltersChangedArgs>) => void;
};

const CalendarFiltersToolbar: FC<Props> = ({ selectedFilters, onFiltersChanged }) => {
  const {
    clinicState: { clinicsAssignedToProvider },
  } = useContext(ClinicContext);

  const handleChangeClinic = (e: SelectChangeEvent): void => {
    onFiltersChanged({ clinicId: parseInt(e.target.value) });
  };

  const handleClearFilters = (): void => {
    onFiltersChanged(DEFAULT_FILTERS);
  };

  return (
    <Stack
      sx={{
        width: '100%',
        marginTop: 2,
        marginBottom: 2,
        padding: 0,
        justifyContent: 'end',
      }}
      direction='row'
      gap={1}>
      <FormControl sx={{ flex: 0.15 }}>
        <InputLabel>Clinics</InputLabel>
        <Select label='Clinics' value={`${selectedFilters.clinicId}`} onChange={handleChangeClinic}>
          {[
            ...clinicsAssignedToProvider.map((clinic, index) => (
              <MenuItem value={clinic.id} key={`${clinic.id}-${index}`}>
                {clinic.name}
              </MenuItem>
            )),
            <MenuItem key='clinics-all' value={FILTER_BY_NO_CLINIC_ID}>
              All
            </MenuItem>,
          ]}
        </Select>
      </FormControl>

      <Tooltip title='Clear Filters' placement='top'>
        <IconButton aria-label='Clear Filters' onClick={handleClearFilters}>
          <FilterAltOff />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default CalendarFiltersToolbar;
